module.exports = __webpack_public_path__ + "assets/svg/Icons/32/notes-blue-d2a759.svg";